import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import Dialog from '../../common/dialog'
import MarkerDetails from '../common/marker-details'
import PhotoDetails from '../common/photo-details'
import DrawObjects from './draw-objects'
import HuntWind from './hunt-wind'
import AddStand from './add-stand'
import AddStand3D from './add-stand/add-stand-3d'
import FindFriends from '../friends/find-friends/index'
import Export from '../import-export/export'
import Friends from '../../left-toolbar/friends/index'
import Import from '../import-export/import'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { enableMapObject } from '../../../../action/disable-map-obj-state-action'
import Favourite from './favorite'
import RouteBuilder from './route-builder'
import ThreeDMarkerDetails from '../../../threedmap/add-3dmap-items/add-marker'
import ThreeDPhotoMarkerDetails from '../../../threedmap/add-3dmap-items/add-photo/add-photo'
import MapObjects from '../../../threedmap/add-3dmap-items/objects'

class Tools extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      // Opened straight onto a tool, e.g. Add Stand from the Weather Center (WEB-7144).
      selectedTab: props.initialTab || '',
      headerValue: props.initialTab ? '' : 'Map Tools',
      selectShape: 'line'
    }
  }

  onClickCLoseToolbar = () => {
    const { collapseLeftToolbar, enableMapObject } = this.props
    collapseLeftToolbar()
    enableMapObject()
  }
  onClickBackToolbar = () => {
    this.setState({ selectedTab: '', headerValue: 'Map Tools' })
  }
  onShapeChange = (shape) => {
    if (this.props.infoWindow) {
      this.props.infoWindow.infoWindowFunction && this.props.infoWindow.infoWindowFunction.close()
    }
    this.setState({ selectShape: shape })
  }

  onTabValue = (label) => {
    if (this.props.infoWindow) {
      this.props.infoWindow.infoWindowFunction && this.props.infoWindow.infoWindowFunction.close()
    }
    this.setState({ headerValue: label })

  }

  render() {
    const { selectedTab, headerValue } = this.state,
      { collapseLeftToolbar } = this.props

    return (
      <div className='left-expanded-content-container'
        style={{ overflow: headerValue === 'Friends' ? 'hidden' : 'scroll' }}
      >

        {/* Route Builder draws its own CREATE ROUTE header (with close). */}
        {this.props.is3dMapselected || selectedTab === 'routeBuilder' ? null :
          <div className='left-expanded-header-container'>
            {selectedTab != '' && <div className='default-back left-dialog-close'
              style={{}}
              onClick={this.onClickBackToolbar}></div>}

            <span className='left-expanded-header'>{headerValue && headerValue}</span>
            <div className='default-close left-dialog-close' onClick={this.onClickCLoseToolbar}></div>
          </div>
        }

        {selectedTab == '' && <>
          <div className='left-expanded-tabs-container'>

            <div className='left-toolbar-header-container'>

              {/* Connect */}
              <div className='left-toolbar-header-Items'><p className='header-text-style'>Connect</p>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {[
                    this.newMakeTab({
                      tab: 'locateFriends',
                      label: 'Locate Friends',
                      active: '../../../../../asset/wind-check-active.png',
                      inactive: '../../../../../asset/wind-check-inactive.png',
                      iconName: 'LocateFriends.png',
                      borderCOlor: null,
                      onTabValue: this.onTabValue,
                      key: 1
                    }, '25%'),
                    this.newMakeTab({
                      tab: 'friends',
                      label: 'Friends',
                      active: '../../../../../asset/wind-check-active.png',
                      inactive: '../../../../../asset/wind-check-inactive.png',
                      iconName: 'LocateFriends.png',
                      borderCOlor: null,
                      onTabValue: this.onTabValue,
                      key: 2
                    }, '25%'),
                  ]}
                </div>
              </div>

              {/* Hunting */}
              <div className='left-toolbar-header-Items'><p className='header-text-style'> Hunting</p>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {[
                    this.newMakeTab({
                      tab: 'huntWind',
                      label: 'Check Wind',
                      active: '../../../../../asset/wind-check-active.png',
                      inactive: '../../../../../asset/wind-check-inactive.png',
                      iconName: 'CheckWind.png',
                      borderCOlor: null,
                      key: 1
                    }, '25%'),

                    this.newMakeTab({
                      tab: 'addStand',
                      label: 'Add Stand',
                      active: '../../../../../asset/stand-icon-active.png',
                      inactive: '../../../../../asset/stand-icon-inactive.png',
                      iconName: 'addStand.png',
                      borderCOlor: null,
                      key: 2
                    }, '25%'),
                  ]}
                </div>
              </div>

              {/*  Mark/Measure/Track */}
              <div className='left-toolbar-header-Items'><p className='header-text-style'> Mark/Measure/Track</p>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {[
                    this.newMakeTab({
                      tab: 'marker',
                      label: 'Add Marker',
                      active: '../../../../../asset/Marker-Generic_Solid_FFFFFF_ldpi.png',
                      inactive: '../../../../../asset/Marker-Generic_Solid_4F4F4F_ldpi.png',
                      iconName: 'AddMarker.png',
                      borderCOlor: null,
                      key: 1
                    }, '25%'),
                    this.newMakeTab({
                      tab: 'photo',
                      label: 'Add Photo',
                      active: '../../../../../asset/Camera_Solid_FFFFFF_ldpi.png',
                      inactive: '../../../../../asset/Camera_Solid_4F4F4F_ldpi.png',
                      iconName: 'AddPhoto.png',
                      borderCOlor: null,
                      key: 2
                    }, '25%'),
                    this.newMakeTab({
                      tab: 'drawObjects',
                      label: 'Draw Polygon',
                      active: '../../../../../asset/Pencil-Ruler_Solid_FFFFFF_ldpi.png',
                      inactive: '../../../../../asset/Pencil-Ruler_Solid_4F4F4F_ldpi.png',
                      iconName: 'DrawPolygon.png',
                      borderCOlor: null,
                      keyVal: 'polygon',
                      onShapeChange: this.onShapeChange,
                      key: 3

                    }, '25%'),

                    this.newMakeTab({
                      tab: 'drawObjects',
                      label: 'Draw Line',
                      active: '../../../../../asset/stand-icon-active.png',
                      inactive: '../../../../../asset/stand-icon-inactive.png',
                      iconName: 'drawLine.png',
                      borderCOlor: null,
                      keyVal: 'line',
                      onShapeChange: this.onShapeChange,
                      key: 4
                    }, '25%'),
                    this.newMakeTab({
                      tab: 'drawObjects',
                      label: 'Draw Circle',
                      keyVal: 'circle',
                      active: '../../../../../asset/stand-icon-active.png',
                      inactive: '../../../../../asset/stand-icon-inactive.png',
                      iconName: 'DrawCircle.png',
                      borderCOlor: null,
                      onShapeChange: this.onShapeChange,
                      key: 5
                    }, '25%'),

                    /* Route Builder is built in with ROUTE_BUILDER=true (set per environment in
                       deployment/*.env); without it the tab is left out. */
                    typeof __ROUTE_BUILDER__ !== 'undefined' && __ROUTE_BUILDER__ === true && this.newMakeTab({
                      tab: 'routeBuilder',
                      label: 'Route Builder',
                      active: '../../../../../asset/stand-icon-active.png',
                      inactive: '../../../../../asset/stand-icon-inactive.png',
                      iconName: 'RouteBuilder.png',
                      borderCOlor: null,
                      disabled: this.props.is3dMapselected,
                      key: 6
                    }, '25%'),

                    this.newMakeTab({
                      tab: 'favoriteLocation',
                      label: 'Favorite Location',
                      active: '../../../../../asset/Marker-Generic_Solid_FFFFFF_ldpi.png',
                      inactive: '../../../../../asset/Marker-Generic_Solid_4F4F4F_ldpi.png',
                      iconName: 'AddMarker.png',
                      borderCOlor: null,
                      key: 7
                    }, '25%'),
                  ]}
                </div>
              </div>

              {/* Import/Export */}
              <div className='left-toolbar-header-Items'><p className='header-text-style'>Import/Export</p>

                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  {[
                    this.newMakeTab({
                      tab: 'import',
                      label: 'Import',
                      active: '../../../../../asset/wind-check-active.png',
                      inactive: '../../../../../asset/wind-check-inactive.png',
                      iconName: 'ImportIcon.png',
                      borderCOlor: null,
                      key: 1
                    }, '25%'),
                    this.newMakeTab({
                      tab: 'export',
                      label: 'Export',
                      active: '../../../../../asset/stand-icon-active.png',
                      inactive: '../../../../../asset/stand-icon-inactive.png',
                      iconName: 'ExportIcon.png',
                      borderCOlor: null,
                      key: 2
                    }, '25%')
                  ]}
                </div>
              </div>

            </div>


          </div>
        </>}
        {
          selectedTab === 'marker' ? this.props.is3dMapselected ? (
            // __NODE_ENV__ != "production" ?
            <ThreeDMarkerDetails />
            // : <></>
          ) : <MarkerDetails /> :
            selectedTab === 'photo' ? this.props.is3dMapselected ? (
              // __NODE_ENV__ != "production" ?
              <ThreeDPhotoMarkerDetails />
              //  : <></>
            ) : <PhotoDetails /> :
              selectedTab === 'drawObjects' ? this.props.is3dMapselected ? (
                // __NODE_ENV__ != "production" ? 
                <MapObjects drawType={this.state.selectShape} />
                // : <></>
              ) : <DrawObjects drawType={this.state.selectShape} /> :
                selectedTab === 'huntWind' ? <HuntWind /> :
                  selectedTab === 'addStand' ? this.props.is3dMapselected ? <AddStand3D /> : <AddStand /> :
                    selectedTab === 'routeBuilder' ? this.props.is3dMapselected ? <></> : <RouteBuilder onClose={this.onClickCLoseToolbar} /> :
                      selectedTab === 'export' ? <Export /> :
                      selectedTab === 'import' ? <Import /> :
                        selectedTab === 'compatibleDevices' ? <></> :
                          selectedTab === 'locateFriends' ? <FindFriends /> :
                            selectedTab === 'friends' ? <Friends /> :
                              selectedTab === 'contactEMS' ? <></> :
                                selectedTab === 'addCamera' ? <></> :
                                  selectedTab === 'harvestLog' ? <></> :
                                    selectedTab === 'favoriteLocation' ? <Favourite closeFavoriteMenu={() => { this.setState({ selectedTab: '', headerValue: 'Map Tools' }) }}></Favourite>
                                      : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  infoWindow: state.infoWindow,
  is3dMapselected: state.is3dMapselected
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  enableMapObject: () => dispatch(enableMapObject())
})

export default connect(mapStateToProps, mapDispatchToProps)(Tools)